import React, { useState } from 'react';
import { Accordion, AccordionItem } from '../ui/Accordion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Tengo que contar calorías?',
    answer: 'No. El método se basa en la calidad de los alimentos y en el sistema de Semáforo, no en matemáticas. Queremos que sanes tu relación con la comida, no que te obsesiones con números.'
  }, {
    question: '¿Tengo que pesarme?',
    answer: 'Es opcional. Recomendamos más guiarte por cómo te queda la ropa y cómo te sientes (energía, digestión) que por el número en la báscula, que puede variar por muchos factores.'
  }, {
    question: '¿Y si tengo que comer fuera?',
    answer: "El ebook incluye reglas simples para navegar menús de restaurantes y un 'Plan Rescate' por si te sales del plan. La idea es progreso, no perfección."
  }, {
    question: '¿Cuándo recibo el material?',
    answer: 'Inmediatamente después de tu pago. Recibirás un correo electrónico con el enlace de descarga para que empieces hoy mismo.'
  }, {
    question: '¿Es apto para vegetarianas?',
    answer: 'Sí, el sistema es flexible y puedes adaptar las fuentes de proteína a opciones vegetales siguiendo las guías del semáforo.'
  }];
  return <section className="py-16 md:py-24 bg-stone-50" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-5">
          <Accordion data-id="element-6">
            {faqs.map((faq, index) => <AccordionItem key={index} title={faq.question} isOpen={openIndex === index} onClick={() => setOpenIndex(index === openIndex ? null : index)} data-id="element-7">
                {faq.answer}
              </AccordionItem>)}
          </Accordion>

          <p className="text-xs text-stone-400 mt-8 text-center max-w-lg mx-auto" data-id="element-8">
            Descargo de responsabilidad: Este producto no sustituye el consejo
            médico profesional. Si tienes condiciones médicas preexistentes,
            consulta a tu médico antes de iniciar cualquier cambio en tu
            alimentación.
          </p>
        </div>
      </div>
    </section>;
}